import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../extras/Title";
import Analytics from "../../extras/Analytics";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import {
  getSalonWalletData,
  getWalletData,
} from "../../../redux/slice/userSlice";
import { useLocation } from "react-router-dom";
import Sign from "../../../assets/images/sign.png";
import With from "../../../assets/images/with.png";
import { ReactComponent as Refund } from "../../../assets/icon/refund.svg";

const SalonHistory = () => {
  const transactionTypeData = [
    { value: "3", label: "Credit" },
    { value: "2", label: "Debit" },
  ];
  const { salonWalletData, total } = useSelector((state) => state.user);
  const { admin } = useSelector((state) => state.auth);
  const { setting } = useSelector((state) => state.setting);
  const { state } = useLocation();
  console.log("statestate", state);
  const [transactionType, setTransactionType] = useState("All");
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const dispatch = useDispatch();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  useEffect(() => {
    const payload = {
      startDate: startDate,
      endDate: endDate,
      start: page,
      limit: rowsPerPage,
      type: transactionType,
      salonId: state?.row?._id,
    };
    dispatch(getSalonWalletData(payload));
  }, [page, rowsPerPage, startDate, transactionType]);

  const walletTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "UniqueId",
      Cell: ({ row }) => (
        <span className="text-capitalize  cursor">{row?.uniqueId || "-"}</span>
      ),
    },
    {
      Header: `Amount (${setting.currencySymbol})`,
      Cell: ({ row }) => (
        <span className="text-capitalize  cursor">{row?.amount || "-"}</span>
      ),
    },
    {
      Header: "Date",
      Cell: ({ row }) => (
        <span className="text-capitalize  cursor">
          {row?.date ? row?.date : "-"}
        </span>
      ),
    },
    {
      Header: "Time",
      Cell: ({ row }) => <div>{row?.time ? row?.time : "-"}</div>,
    },
    {
      Header: "Transaction Type",
      Cell: ({ row }) =>
        //   return <button className="badge-danger ">Credit</button>;
        // },
        row?.type === 3 ? (
          <button className="badge-success ">Credit</button>
        ) : row?.type === 4 ? (
          <button className="badge-success ">Credit</button>
        ) : row?.type === 2 && row?.payoutStatus === 2 ? (
          <button className="badge-danger">Debit</button>
        ) : (
          <button className="badge-primary">Pending</button>
        ),
    },
    {
      Header: "Transaction Completed",
      Cell: ({ row }) => {
        // return(  <button
        //           className="badge-warning"
                 
        //         >
                  
        //           {/* <span style={{ whiteSpace: "nowrap" }}>
        //             {(row?.payoutStatus === 1 && "Withdraw Pending") ||
        //               (row?.payoutStatus === 2 && "Withdraw Approve") ||
        //               (row?.payoutStatus === 3 && "Withdraw Declined")}
        //           </span> */}
        //           Hello
        //         </button>)
       

        return (

          row?.type === 2 ? (
            <>

              {row?.payoutStatus === 1 ? (
                <button className="badge-success">
                  {(row?.payoutStatus === 1 && "Withdraw Pending") ||
                    (row?.payoutStatus === 2 && "Withdraw Approve") ||
                    (row?.payoutStatus === 3 && "Withdraw Declined")}
                </button>
              ) : (
                <button className="badge-warning">
                  
                    {(row?.payoutStatus === 1 && "Withdraw Pending") ||
                      (row?.payoutStatus === 2 && "Withdraw Approve") ||
                      (row?.payoutStatus === 3 && "Withdraw Declined")}
             
                </button>
              )}
            </>
          ) : row?.type === 3 ? (
            <button
              className="badge-success">
            Order confirmed
            </button>
          ) : row?.type === 4 ? (
            <button
              className="badge-success">
              
              Booking Completed
            </button>
          ) : (
            ""
          )
        )
      }
    },
  ];

  return (
    <>
      <div className="userPage">
        <div className=" d-flex justify-content-end mb-3">
          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            placeholder="Wallet"
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
        </div>
        <div className="user-table mb-3">
          <div className="user-table-top">
            <div className=" d-flex justify-content-between align-items-center w-100 ">
              <div className="w-100">
                <h5 className="main-title">Wallet History</h5>
              </div>
              <div className="d-flex gap-2 justify-content-end w-100">
                <div className="inputData pb-2 w-50">
                  <select
                    name="transactionType"
                    className="form-select"
                    id="transactionType"
                    value={transactionType}
                    onChange={(e) => {
                      const selectedSalonId = e.target.value;
                      const payload = {
                        startDate: startDate,
                        endDate: endDate,
                        start: page,
                        limit: rowsPerPage,
                        type: transactionType,
                        salonId: state?.row?._id,
                      };
                      dispatch(getSalonWalletData(payload));
                      setTransactionType(selectedSalonId);
                    }}
                  >
                    <option key="All" value="All">
                      All
                    </option>
                    {transactionTypeData?.map((data) => (
                      <option key={data?.value} value={data?.value}>
                        {data?.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="betBox"></div>

          <Table
            data={salonWalletData}
            rowsPerPage={rowsPerPage}
            page={page}
            mapData={walletTable}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>
      </div>
    </>
  );
};

export default SalonHistory;
